/**
 *  @class
 *  @function FreeShipping
 */

if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {

      this.regionSelect = this.querySelector('.free-shipping--region-select');
      this.promptText = this.querySelector('.free-shipping--text-prompt');
      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');
      this.progressBar = this.querySelector('.free-shipping--bar');

      let savedRegion = '';
      try {
        savedRegion = window.localStorage.getItem('mxpet-shipping-region') || '';
      } catch (error) {
        savedRegion = '';
      }

      if (this.regionSelect.querySelector(`option[value="${savedRegion}"]`)) {
        this.regionSelect.value = savedRegion;
      }

      this.regionSelect.addEventListener('change', () => {
        try {
          window.localStorage.setItem('mxpet-shipping-region', this.regionSelect.value);
        } catch (error) {
          // The estimate still works when browser storage is unavailable.
        }
        this.updateEstimate();
      });

      this.updateEstimate();
    }

    updateEstimate() {
      const region = this.regionSelect.value;
      const total = parseInt(this.dataset.cartTotal, 10) || 0;
      const thresholds = {
        bc: parseInt(this.dataset.bcMinimum, 10),
        canada: parseInt(this.dataset.canadaMinimum, 10),
        us: parseInt(this.dataset.usMinimum, 10)
      };

      this.promptText.style.display = 'none';
      this.remainingText.style.display = 'none';
      this.fullText.style.display = 'none';

      if (!region) {
        this.promptText.style.display = 'block';
        this.progressBar.hidden = true;
        this.style.setProperty('--percentage', 0);
        return;
      }

      const minimum = Math.round(thresholds[region] * (Shopify.currency.rate || 1));
      const percentage = Math.min(total / minimum, 1);
      this.progressBar.hidden = false;
      this.style.setProperty('--percentage', percentage);

      if (total < minimum) {
        const remaining = minimum - total;
        const amountText = this.remainingText.querySelector('span');
        const format = window.theme.settings.money_with_currency_format || "${{amount}}";
        amountText.innerHTML = formatMoney(remaining, format);
        this.remainingText.style.display = 'block';
      } else {
        this.fullText.style.display = 'block';
      }

    }
  }
  customElements.define('free-shipping', FreeShipping);
}
